import Icon from 'src/common/components/Icon';

import * as S from './layout';

interface Props {
  name: string;
}

const BasicItem = ({ name }: Props) => (
  <S.BasicItemContainer>
    <S.BasicItemCard>
      <Icon name="ingredient" size={20} />
    </S.BasicItemCard>
    <S.BasicIngredientName>{name}</S.BasicIngredientName>
  </S.BasicItemContainer>
);

export default BasicItem;
